import en_GB from "./en-GB";
import en_US from "./en-US";

export * from "./enums";

export default {
  enGB: en_GB,
  enUS: en_US
};
